import React, { FunctionComponent, useEffect, useRef } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import lottie, { AnimationItem } from "lottie-web";

import loaderAnimation from "./loader.json";
import { Main } from "./styled";

const LoaderDots: FunctionComponent = () => {
  const ref = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (!ref.current) return () => null;

    instanceRef.current = lottie.loadAnimation({
      container: ref.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: loaderAnimation,
    });

    return () => {
      instanceRef.current?.destroy();
    };
  }, []);

  return <Main ref={ref} />;
};

export default LoaderDots;
